import React, { useCallback, useEffect, useReducer, useState } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import SocketContext from "@SocketContext";
import Typography from "@material-ui/core/Typography";
import { skip } from "rxjs/operators/index";
import { userMessageService } from "./_services/userMessage.service";
import userMessagesService from "../Services/UserMessagesService";
import { v4 as uuid_v4 } from "uuid";
import Box from '@material-ui/core/Box';
import Tooltip from "@material-ui/core/Tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import IconButton from '@material-ui/core/IconButton';
import { useHistory } from "react-router-dom";
import { useCookies } from 'react-cookie';
import { useUserMode } from "@UserModeContext";
const CustomListItemText = withStyles({
  root: {
    margin: 0,
    borderBottom: '2px solid black',
  },
})(ListItemText);
const Accordion = withStyles({
  root: {
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    marginBottom: -1,
    minHeight: 28,
    padding: "0",
    backgroundColor: '#ECECEE',
  },
  content: {
    margin: 0,
    flexDirection: 'column',
    '&$expanded': {
      margin: 0,
    }
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {

    backgroundColor: '#ECECEE',
    // color: "white",
    padding: "0 2%",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
  },
}))(MuiAccordionDetails);

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  messageTitle: {
    fontWeight: "bold!important",
  },
  contentPre: {
    fontSize: "16px",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    margin: 0,
    marginTop: '15px'
  },
  itemList: {
    padding: 0,
    margin: 0,

  },
  ListItemSubject: {
    width: '100%',
    padding: '0 5px',
  },
  ListItemHeader: {
    width: '100%',
    fontSize: '0.7rem',
    fontWeight: 'bold',
    padding: '0 5px'
  },
  linkButton: {
    alignSelf: 'flex-start',
  },
  sysMessageContainer: {
    display: 'flex',
    flexDirection: 'row',

  },
  messageContent: {
    wordWrap: 'break-word',
    textAlign: 'justify',
  },

  MessagesPanel: {
    width: "100%",
    maxHeight: 'calc(90vh - 395px)',
    overflow: "auto",
  },
}));

const messagesReducer = (state, action) => {
  switch (action.type) {
    case "INIT_VALUES":
      return action.data;
    case "ADD_VALUES":
      return [...state, ...action.data];
    case "SET_READ":
      return state.map((item) => {
        if (item.id === action.messageId && item.job_id === action.jobId) {
          item.read = 1;
        }
        return item;
      });
    default:
      return state;
  }
};

const AdMessageWorkerComponent = (props) => {
  const { socket } = props;
  const classes = useStyles();
  const [messagesList, messagesDispatch] = useReducer(messagesReducer, []);
  const [isLoading, setIsLoading] = useState(false);
  const [rowCount, setRowCount] = useState();
  const refreshAdsList = useCallback((page = 1) => {
    setIsLoading(true);
    userMessagesService.adsList(page).then((response) => {
      messagesDispatch({ type: page === 1 ? "INIT_VALUES" : "ADD_VALUES", data: response.messages });
      updateAdsMessageCounter(response.counter);
      setRowCount(response.row_count);
      setIsLoading(false);
    });
  }, []);
  const readMessage = useCallback((messageId, read) => {
    if (read) return;

    userMessagesService.setAdsRead(messageId).then((response) => {
      if (response.status === 200) {
        messagesDispatch({ type: "SET_READ", messageId: messageId });
        updateAdsMessageCounter(response.data.counter);
      }
    });
  }, []);

  useEffect(() => {
    refreshAdsList();
  }, [refreshAdsList]);

  useEffect(() => {
    socket.on('refresh-ads-messages', ((event) => {
      (async () => {
        await refreshAdsList();
      })();
    }));
    return () => {
      socket.off(`refresh-ads-messages`);
    }
  }, [socket, refreshAdsList]);
  useEffect(() => {
    const subscription = userMessageService.getMessageComponentMessage().pipe(skip(1)).subscribe(type => {

      if (type === 2) {
        userMessagesService.setAllAdsRead().then((response) => {
          if (response.status === 200) {
            (async () => {
              await refreshAdsList();
            })();
          }
        });
      }
    });
    return () => subscription.unsubscribe();
  }, [readMessage, refreshAdsList]);

  const updateAdsMessageCounter = (counter) => {
    userMessageService.adMessageCounterMessage({ counter: counter });
  };

  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom && !isLoading && messagesList.length < rowCount - 1) {
      (async () => {
        await refreshAdsList(Math.floor(messagesList.length / 10) + 1);
      })();
    }
  }

  useEffect(() => {
    const closeDialogSubscription = userMessageService
      .getToggleDrawer()
      .pipe(skip(1))
      .subscribe((m) => {
        messagesDispatch({ type: "INIT_VALUES", data: [] });
        (async () => {
          await refreshAdsList();
        })()
      });
    return () => {
      closeDialogSubscription.unsubscribe();
    };
  }, [refreshAdsList]);
  return (
    <div onScroll={handleScroll} className={classes.MessagesPanel}>

      <List dense>
        {messagesList.length === 0 ? (
          <ListItem>
            <ListItemText
              primary={
                <React.Fragment>
                  <Typography variant="body2" component="span">
                    Brak wiadomosci
                  </Typography>
                </React.Fragment>
              }
            />
          </ListItem>
        ) : (
          messagesList.map((m) => (
            <ListItem
              key={`message-item-1-${m.id}`}
              button
              onClick={() => readMessage(m.id, m.read)}
              className={classes.itemList}
            >
              <CustomListItemText
                primary={
                  <Accordion square>
                    <AccordionSummary>
                      <Box component="div" className={classes.ListItemHeader}>
                        {m.created_at}<br />
                        {"Priorytet "}
                        {m.priority === 1 && "niski"}
                        {m.priority === 2 && "normalny"}
                        {m.priority === 3 && "wysoki"}
                      </Box>
                      <Box component="div" className={classes.ListItemSubject}>
                        <Typography
                          variant="body2"
                          component="span"
                          className={m.read ? "" : classes.messageTitle}
                        >
                          {m.subject}
                        </Typography>
                      </Box>



                    </AccordionSummary>
                    <AccordionDetails>
                      <Box component="div" className={classes.messageContent}>
                        {m.content}
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                }
              />
            </ListItem>
          ))
        )}
      </List>
    </div>
  );
};

const BusMessageWorkerComponent = (props) => {
  const { socket } = props;
  const classes = useStyles();
  const [messagesList, messagesDispatch] = useReducer(messagesReducer, []);
  const [isLoading, setIsLoading] = useState(false);
  const [rowCount, setRowCount] = useState();

  const refreshBusList = useCallback((page = 1) => {
    setIsLoading(true);
    userMessagesService.busList(page).then((response) => {
      messagesDispatch({ type: page === 1 ? "INIT_VALUES" : "ADD_VALUES", data: response.messages });
      updateBusMessageCounter(response.counter);
      setRowCount(response.row_count);
      setIsLoading(false);
    });
  }, []);

  const readMessage = useCallback((messageId, read) => {
    if (read) return;

    userMessagesService.setBusRead(messageId).then((response) => {
      if (response.status === 200) {
        messagesDispatch({ type: "SET_READ", messageId: messageId });
        updateBusMessageCounter(response.data.counter);
      }
    });
  }, []);

  useEffect(() => {
    refreshBusList();
  }, [refreshBusList]);

  useEffect(() => {
    socket.on('refresh-bus-messages', ((event) => {
      (async () => {
        await refreshBusList();
      })();
    }));
    return () => {
      socket.off(`refresh-bus-messages`);
    }
  }, [socket, refreshBusList]);

  useEffect(() => {
    const subscription = userMessageService.getMessageComponentMessage().pipe(skip(1)).subscribe(type => {
      if (type === 1) {
        userMessagesService.setAllBusRead().then((response) => {
          if (response.status === 200) {
            (async () => {
              await refreshBusList();
            })();
          }
        });
      }
    });
    return () => subscription.unsubscribe();
  }, [readMessage, refreshBusList]);

  const updateBusMessageCounter = (counter) => {
    userMessageService.busMessageCounterMessage({ counter: counter });
  };

  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom && !isLoading && messagesList.length < rowCount - 1) {
      (async () => {
        await refreshBusList(Math.floor(messagesList.length / 10) + 1);
      })();
    }
  }

  useEffect(() => {
    const closeDialogSubscription = userMessageService
      .getToggleDrawer()
      .pipe(skip(1))
      .subscribe((m) => {
        messagesDispatch({ type: "INIT_VALUES", data: [] });
        (async () => {
          await refreshBusList();
        })()
      });
    return () => {
      closeDialogSubscription.unsubscribe();
    };
  }, [refreshBusList]);
  return (
    <div onScroll={handleScroll} className={classes.MessagesPanel}>
      <List dense>
        {messagesList.length === 0 ? (
          <ListItem>
            <CustomListItemText
              primary={
                <React.Fragment>
                  <Typography variant="body2" component="span">
                    Brak wiadomosci
                  </Typography>
                </React.Fragment>
              }
            />
          </ListItem>
        ) : (
          messagesList.map((m, index) => (
            <ListItem
              key={`message-item-2-${m.id}-${index}`}
              button
              onClick={() => readMessage(m.id, m.read)}
              className={classes.itemList}
            >
              <CustomListItemText
                primary={
                  <Accordion square>
                    <AccordionSummary>
                      <Box component="div" className={classes.ListItemHeader}>
                        {m.created_at}<br />
                        {"Priorytet "}
                        {m.priority === 1 && "niski"}
                        {m.priority === 2 && "normalny"}
                        {m.priority === 3 && "wysoki"}
                      </Box>
                      <Box component="div" className={classes.ListItemSubject}>
                        <Typography
                          variant="body2"
                          component="span"
                          className={m.read ? "" : classes.messageTitle}
                        >
                          {m.subject}
                        </Typography>
                      </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box component="div" className={classes.messageContent}>
                        {m.content}
                      </Box>

                    </AccordionDetails>
                  </Accordion>
                }
              />
            </ListItem>
          ))
        )}
      </List>
    </div>
  );
};

const SysMessageWorkerComponent = (props) => {
  const { socket } = props;
  const classes = useStyles();
  const history = useHistory();
  const [, setCookie] = useCookies();
  const [messagesList, messagesDispatch] = useReducer(messagesReducer, []);
  const userModeState = useUserMode();
  const [isLoading, setIsLoading] = useState(false);
  const [rowCount, setRowCount] = useState();
  const refreshSysList = useCallback((page = 1) => {
    setIsLoading(true);
    userMessagesService.sysList(page).then((response) => {
      messagesDispatch({ type: page === 1 ? "INIT_VALUES" : "ADD_VALUES", data: response.messages });
      updateSysMessageCounter(response.counter);
      setRowCount(response.row_count);
      setIsLoading(false);

    });
  }, []);

  const readMessage = useCallback((messageId, jobId, read) => {
    if (read) return;

    userMessagesService.setSysRead(messageId, jobId).then((response) => {
      if (response.status === 200) {
        messagesDispatch({
          type: "SET_READ",
          messageId: messageId,
          jobId: jobId,
        });
        updateSysMessageCounter(response.data.counter);
      }
    });
  }, []);

  useEffect(() => {
    refreshSysList();
  }, [refreshSysList]);




  useEffect(() => {
    socket.on('system-message', ((event) => {
      (async () => {
        await refreshSysList();
      })();
    }));
    return () => {
      socket.off(`system-message`);
    }
  }, [socket, refreshSysList]);


  useEffect(() => {
    const subscription = userMessageService.getMessageComponentMessage().pipe(skip(1)).subscribe(type => {
      if (type === 3) {
        userMessagesService.setAllSysRead().then((response) => {
          if (response.status === 200) {
            (async () => {
              await refreshSysList();
            })();
          }
        });
      }
    });
    return () => subscription.unsubscribe();
  }, [readMessage, refreshSysList]);

  const updateSysMessageCounter = (counter) => {
    userMessageService.sysMessageCounterMessage({ counter: counter });
  };
  const handleOpenDoc = (m) => {
    switch (m.type) {
      case 3: // PUBLIKACJA
        if (!userModeState.userMode)
          userModeState.toggle();
        setCookie('documentsROPanel', 'documents', { path: '/' });
        setCookie('documentsActiveItem', m.link, { path: '/' });
        if(m.subject.indexOf("Sprawdź") === 0) {
          history.push({
            pathname: "/dokumenty-zwiazane",
          });
        } else {
          history.push({
            pathname: "/dokumenty",
          });
        }
        break;
      case 4: // ODRZUCONY
        if (userModeState.userMode)
          userModeState.toggle();
        setCookie('documentsPanel', 'documents', { path: '/' });
        setCookie('documentsActiveItem', m.link, { path: '/' });
        history.push({
          pathname: "/edycja-dokumentow",
        });
        break;
      case 6: // PRZEKAZANO DFC
      case 7: // COFNIĘTO DFC
        if (!userModeState.userMode)
          userModeState.toggle();
        setCookie('documentsROPanel', 'tasks', { path: '/' });
        setCookie('documentsActiveItem', m.link, { path: '/' });

        history.push({
          pathname: "/dokumenty",
        });
        break;
      default:
        if (userModeState.userMode)
          userModeState.toggle();
        setCookie('documentsPanel', 'verify-documents', { path: '/' });
        history.push({
          pathname: "/edycja-dokumentow",
        });
        break;


    }

  }
  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom && !isLoading && messagesList.length < rowCount - 1) {
      (async () => {
        await refreshSysList(Math.floor(messagesList.length / 25) + 1);
      })();
    }
  }

  useEffect(() => {
    const closeDialogSubscription = userMessageService
      .getToggleDrawer()
      .pipe(skip(1))
      .subscribe((m) => {
        messagesDispatch({ type: "INIT_VALUES", data: [] });
        (async () => {
          await refreshSysList();
        })()
      });
    return () => {
      closeDialogSubscription.unsubscribe();
    };
  }, [refreshSysList]);
  return (
    <div onScroll={handleScroll} className={classes.MessagesPanel}>
      <List dense>
        {messagesList.length === 0 ? (
          <ListItem>
            <CustomListItemText
              primary={
                <React.Fragment>
                  <Typography variant="body2" component="span">
                    Brak wiadomosci
                  </Typography>
                </React.Fragment>
              }
            />
          </ListItem>
        ) : (
          messagesList.map((m) => (
            <ListItem
              key={`message-item-${uuid_v4()}`}
              button
              onClick={() => readMessage(m.id, m.job_id, m.read)}
              className={classes.itemList}
            >

              <CustomListItemText
                primary={
                  <>
                    <Box component="div" className={classes.ListItemHeader}>
                      {m.created_at}<br />
                      {m.author}
                    </Box>
                    <Box component='div' className={classes.sysMessageContainer}>

                      <Box component="div" className={classes.ListItemSubject}>
                        <Typography
                          variant="body2"
                          component="span"
                          className={m.read ? "" : classes.messageTitle}
                        >
                          {m.subject}
                        </Typography>
                      </Box>
                      <Tooltip title="Przejdź do dokumentu">
                        <IconButton size="small" onClick={(e) => { e.stopPropagation(); handleOpenDoc(m); }} className={classes.linkButton}>
                          <FontAwesomeIcon aria-label={"fa-link"} icon={faLink} className={classes.iconSize} />
                        </IconButton>
                      </Tooltip>


                    </Box>
                  </>
                }
              />
            </ListItem>
          ))
        )}
      </List>
    </div>
  );
};

export const AdMessageWorkerWithSocket = (props) => (
  <SocketContext.Consumer>
    {(socket) => <AdMessageWorkerComponent {...props} socket={socket} />}
  </SocketContext.Consumer>
);

export const BusMessageWorkerWithSocket = (props) => (
  <SocketContext.Consumer>
    {(socket) => <BusMessageWorkerComponent {...props} socket={socket} />}
  </SocketContext.Consumer>
);

export const SysMessageWorkerWithSocket = (props) => (
  <SocketContext.Consumer>
    {(socket) => <SysMessageWorkerComponent {...props} socket={socket} />}
  </SocketContext.Consumer>
);
